'use strict';
import axios from 'axios';
var ArctickClient = require('../../../sdk/apiClient');
var util = require('util');

function TraceRecord() {
    ArctickClient.apply(this, arguments);
}
const pluginId = process.env.TRAZABILIDAD;

util.inherits(TraceRecord, ArctickClient);

    /* *** Request POST:  TraceRecords *** */
    TraceRecord.prototype.GetTraceRecords = function () {      
   
        var deferred = $.Deferred();
        let url = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + pluginId + "/GetTraceRecords_service.php";    
        
        
        let config = {
            headers:{
                'Content-Type': 'application/json'
            }
        }
    
        axios.post(url,config)
        .then(response => {
    
            deferred.resolve(response.data);
            //console.log(response.data);
            
        })
        .catch(error => console.error(error));
    
        return deferred.promise();
    }

        /* *** Request POST:  TrackingEstafeta *** */
    TraceRecord.prototype.GetTrackingEstafeta = function (guidenumber) {
            
        var deferred = $.Deferred();
            let url = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + pluginId + "/GetTrackingEstafeta_service.php";
        
            const requestBody = {
                "guidenumber": guidenumber
            };

            let config = {
                headers:{
                    'Content-Type': 'application/json'
                }
            }
        
            axios.post(url,requestBody,config)
            .then(response => {
        
                deferred.resolve(response.data);
                //console.log(response.data);
                
            })
            .catch(error => console.error(error));
        
            return deferred.promise();
    }


module.exports = TraceRecord;
